import React from 'react';
import { job } from '../../lib/Jobs';
import { Grid, Row, Col, Panel, FormGroup, Checkbox, Button, Radio, Image } from 'react-bootstrap';
import Loading from '../../components/Loading';
import { handleHttpResponse } from '../../lib/Helpers';
import Helpers from '../../lib/Helpers';
import DateHelpers from '../../lib/DateHelpers';
import { readableJobStatus } from '../../lib/FormatHelpers';

class JobRow extends React.Component {
  state = {
    loading: false,
    swipecast_internal_notes: this.props.job.swipecast_internal_notes,
    approved: !this.props.job.hidden,
    notification_date: this.props.job.potential_applicants_notification_date,
    manual_ordering: this.props.job.manual_ordering,
  };
  loading() {
    if (this.state.loading) {
      return <Loading />;
    }
  }
  internalNotes() {
    if (this.state.swipecast_internal_notes) {
      return (
        <Row style={{ marginTop: '20px' }}>
          <Col xs={12}>
            <Row>
              <Col xs={12} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                Internal Notes
              </Col>
            </Row>
            <Row style={{ marginTop: '15px' }}>
              <Col xs={12} style={{ textAlign: 'center', whiteSpace: 'pre-line' }}>
                {this.state.swipecast_internal_notes}
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }
  }

  notes() {
    if (this.props.job.project.notes) {
      return (
        <Row>
          <Col xs={12}>
            <Row>
              <Col xs={12} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                Notes
              </Col>
            </Row>
            <Row style={{ marginTop: '15px' }}>
              <Col xs={12} style={{ textAlign: 'center', whiteSpace: 'pre-line' }}>
                {this.props.job.project.notes}
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }
  }

  thirdPartyEmail() {
    if (this.props.job.third_party_email) {
      return (
        <Row>
          <Col xs={4}>
            <strong>Third Party:</strong>
          </Col>
          <Col md={8}>{this.props.job.third_party_email}</Col>
        </Row>
      );
    }
  }

  panelStyle() {
    const style = {};
    if (this.props.job.panelColor()) {
      style.bsStyle = this.props.job.panelColor();
    }
    return style;
  }

  hours() {
    if (this.props.job.hours) {
      return (
        <Row>
          <Col xs={4}>
            <strong>Nº of hours:</strong>
          </Col>
          <Col md={8}>{this.props.job.hours}</Col>
        </Row>
      );
    }
  }

  days() {
    if (this.props.job.days) {
      return (
        <Row>
          <Col xs={4}>
            <strong>Nº of days:</strong>
          </Col>
          <Col md={8}>{this.props.job.days}</Col>
        </Row>
      );
    }
  }

  bookee() {
    if (this.props.job.bookee) {
      return (
        <Row>
          <Col xs={4}>
            <strong>Bookee:</strong>
          </Col>
          <Col md={8}>{this.props.job.bookee}</Col>
        </Row>
      );
    }
  }

  lookingForData() {
    if (this.props.job.looking_for_data) {
      return (
        <Row>
          <Col md={8}>{JSON.stringify(this.props.job.looking_for_data)}</Col>
        </Row>
      );
    }
  }

  edit(key, value) {
    const newState = {};
    newState[key] = value;
    this.setState(Object.assign({}, newState, { loading: true }));
    const self = this;
    const update = this.props.job.update(newState);
    update
      .then(response =>
        handleHttpResponse(response)
          .then((result) => {
            console.log(result);
            self.setState({ loading: false });
          })
          .catch((err) => {
            console.log(err);
            self.setState({ loading: false });
          }))
      .catch((err) => {
        console.log('There was an error, please try again');
        self.setState({ loading: false });
        //* *TODO: send response over to SC engineers
      });
  }

  approve = async (manual_ordering, editorial_tier, commercial_tier) => {
    this.setState({ loading: true });
    try {
      const update = await this.props.job.approve(manual_ordering, editorial_tier, commercial_tier);
      const response = await handleHttpResponse(update);
      this.props.job.hidden = false;
      console.log(response);
      this.setState({
        loading: false,
        approved: true,
      });
    } catch (err) {
      console.log('There was an error, please try again');
      console.log(err);
      this.setState({ loading: false });
    }
  };

  unexpire = async (days) => {
    this.setState({ loading: true });
    try {
      const update = await this.props.job.unexpire(days);
      const response = await handleHttpResponse(update);
      window.location.reload();
    } catch (err) {
      this.setState({ loading: false });
      alert(err);
    }
  };

  markAsCanceled = async () => {
    this.setState({ loading: true });
    try {
      const update = await this.props.job.markAsCanceled();
      const response = await handleHttpResponse(update);
      window.location.reload();
    } catch (err) {
      this.setState({ loading: false });
      alert(err);
    }
  };

  markAsCompleted = async () => {
    this.setState({ loading: true });
    try {
      const update = await this.props.job.markAsCompleted();
      const response = await handleHttpResponse(update);
      window.location.reload();
    } catch (err) {
      this.setState({ loading: false });
      alert(err);
    }
  };

  notify = async (lat, lng, radius) => {
    this.setState({ loading: true });
    try {
      const update = await this.props.job.notify(lat, lng, radius);
      const response = await handleHttpResponse(update);
      console.log(response);
      this.setState({
        loading: false,
        notification_date: response.result.date,
      });
    } catch (err) {
      console.log('There was an error, please try again');
      console.log(err);
      this.setState({ loading: false });
    }
  };

  hide = async (lat, lng, radius) => {
    this.setState({ loading: true });
    try {
      const update = await this.props.job.hide();
      const response = await handleHttpResponse(update);
      console.log(response);
      this.setState({
        loading: false,
        approved: false,
      });
      this.props.job.hidden = true;
    } catch (err) {
      console.log('There was an error, please try again');
      console.log(err);
      this.setState({ loading: false });
    }
  };

  hideButton() {
    if (this.state.approved) {
      return (
        <Button
          bsStyle="info"
          style={{ marginLeft: '20px' }}
          disabled={this.state.loading}
          onClick={this.hide.bind(this)}
        >
          Hide
        </Button>
      );
    }
  }

  notificationText() {
    let buttonText = 'Notification Queued to be sent out.';
    if (this.props.job.people_reached_with_notification) {
      buttonText = `${this.props.job.people_reached_with_notification} people notified.`;
    }
    return buttonText;
  }

  editManualOrderingButton() {
    return (
      <Button
        style={{ marginLeft: '20px' }}
        onClick={() =>
          this.props.showEditNumberModal(
            'Edit Manual Ordering',
            'Manual Ordering',
            'Ok',
            this.state.manual_ordering,
            (manual_ordering) => {
              this.edit('manual_ordering', parseInt(manual_ordering));
            },
          )
        }
      >
        Edit Manual Ordering
      </Button>
    );
  }

  cancelJobButton() {
    return (
      <Button
        bsStyle="danger"
        style={{ marginLeft: '20px' }}
        disabled={this.state.loading}
        onClick={() => this.props.showCancelJobModal('Cancel Job', () => this.markAsCanceled())}
      >
        Cancel
      </Button>
    );
  }

  completeJobButton() {
    return (
      <Button
        bsStyle="danger"
        style={{ marginLeft: '20px' }}
        disabled={this.state.loading}
        title="Marks job as completed"
        onClick={() => this.props.showCancelJobModal('Complete Job', () => this.markAsCompleted())}
      >
        Complete
      </Button>
    );
  }

  firstColumnButton() {
    if (this.props.job.status == 'expiredJob') {
      return (
        <div>
          <Button
            bsStyle="danger"
            style={{ marginLeft: '20px' }}
            disabled={this.state.loading}
            onClick={() =>
              this.props.showEditNumberModal(
                'Unexpire Job',
                'Number of Days',
                'Unexpire',
                0,
                days => this.unexpire(days),
              )
            }
          >
            Unexpire Job
          </Button>
          {this.cancelJobButton()}
        </div>
      );
    }
    if (this.state.approved) {
      return (
        <div>
          {this.hideButton()}
          {this.cancelJobButton()}
          {this.completeJobButton()}
        </div>
      );
    }
    return (
      <div>
        <Button
          bsStyle="danger"
          style={{ marginLeft: '20px' }}
          disabled={this.state.loading}
          onClick={() =>
            this.props.showApproveJobModal(
              0,
              0,
              0,
              (manual_ordering, editorial_tier, commercial_tier) =>
                this.approve(manual_ordering, editorial_tier, commercial_tier),
            )
          }
        >
          Approve Job
        </Button>
        {this.cancelJobButton()}
      </div>
    );
  }

  cardChargeFailedText = () => {
    const cardChargeFailedLedger = this.props.job.ledger.filter(item => {
      return item.action !== 'adminUnexpireJob' && item.new_status === 'cardChargeFailed'
    });
    const diffInSeconds = DateHelpers.differenceBetweenTimeStampsInS(
      new Date(),
      cardChargeFailedLedger[cardChargeFailedLedger.length - 1].timestamp,
    );
    const days = Math.round(diffInSeconds / 60 / 60 / 24);
    const color = days <= 3 ? '#f0ad4e' : days > 3 && days <= 5 ? 'red' : '#931a1e';
    return (
      <div>
        <br />Last Attempt date:{' '}
        {DateHelpers.timeStampToLabel(cardChargeFailedLedger[cardChargeFailedLedger.length - 1].timestamp)}
        <br />
        <span style={{ color }}>({days} days ago)</span>
      </div>
    );
  };

  getRowColor() {
    const { job } = this.props;
    const isFirstPosting = job.project.is_first_posting

    if (isFirstPosting) return '#d2beff'
    return this.state.approved ? 'white' : '#eee'
  }

  render() {
    const self = this;
    const { job } = this.props;

    return (
      <tr style={{ backgroundColor: this.getRowColor() }}>
        {this.props.fields.map((field, index) => {
          if (field.id === 'is_expired') {
            return <td key={index}>{job.status == 'expiredJob'? 'EXPIRED' : 'Live' }</td>
          }
          if (field.id === 'approved') {
          return <td key={index}>{!!self.props.job.project.user.waitlisted ? 'NOT APPROVED; ON WAITLIST' : 'Yes'}</td>
          }
          if (field.id === 'unexpire' || field.id === 'approve') {
            return <td key={index}>{this.firstColumnButton()}</td>
          }
          if (field.id === 'notification') {
            return (<td key={index}>
              {this.state.approved ? (
                this.state.notification_date ? (
                  this.notificationText()
                ) : (
                  <Button
                    bsStyle="warning"
                    style={{ marginLeft: '20px' }}
                    disabled={this.state.loading}
                    onClick={() =>
                      this.props.showNotificationModal((lat, lng, radius) =>
                        this.notify(lat, lng, radius))
                    }
                  >
                    {' '}
                    Notify{' '}
                  </Button>
                )
              ) : (
                'Need to approve before sending'
              )}
            </td>);
          }
          if (field.id === 'name') {
            return (<td key={index}>
              {self.props.job.project.name}
              {self.props.job.salesforce_opportunity_link && (
                <li>
                  <a href={self.props.job.salesforce_opportunity_link} target="_blank">Salesforce Opportunity</a>
                </li>
              )}
                <li>
                  <a href={`https://www.swipecast.com/third_party_pay/${self.props.job.secret_alias_id}`} target="_blank">Payment Link</a>
                </li>
            </td>);
          }
          if (field.id === 'hidden') {
          return <td key={index}>{job.hidden ? 'YES' : 'NO'}</td>
          }
          if ( field.id === 'approved_by') {
          return <td key={index}>{job.approvedBy()}</td>
          }
          if (field.id === 'type') {
            return <td key={index}>{job.booking == true ? 'Direct Booking' : 'Posted project'}</td>
          }
          if (field.id === 'previous_status' || field.id == 'status') {
            return (<td key={index} style={{ minWidth: '150px'}}>
              {job.status != 'expiredJob' && readableJobStatus(job.status)}
              {job.status == 'expiredJob' && job.ledger.slice(-2)[0].new_status}
              {job.status === 'cardChargeFailed' && this.cardChargeFailedText()}
            </td>);
          }
          if (field.id === 'rate') {
            return <td key={index}>
              {self.props.job.rate} {self.props.job.currency.toUpperCase()}
            </td>
          }
          if (field.id === 'total_rate') {
          return <td key={index}>{self.props.job.totalRate()} {self.props.job.currency.toUpperCase()}</td>;
          }
          if (field.id === 'client_admin') {
            return <td key={index}>
              <a
                target="_blank"
                href={`/users/${self.props.job.project.user.swipecast_user_id}`}
              >
                {' '}
                {self.props.job.project.user.full_name}
              </a>
            </td>
          }
          if (field.id === 'client') {
            return <td key={index}>
              <a
                target="_blank"
                href={`${Helpers.frontendURL}/${self.props.job.project.user.swipecast_user_id}`}
              >
                {' '}
                {self.props.job.project.user.full_name}
              </a>
            </td>
          }
          if (field.id === 'talent') {
          return <td key={index}>{self.props.job.bookee ? self.props.job.bookee : 'N/A'}</td>
          }
        if (field.id === 'bank_info') {
          return <td key={index}>{self.props.job.bookee_bank_info_included ? 'YES' : 'NO'}</td>;
        }
        if (field.id === 'looking_for') {
          return (<td key={index}>
            {job.looking_for_data && job.looking_for_data.gender
              ? `${job.looking_for_data.gender} model`
              : job.looking_for}
          </td>);
        }
        if (field.id === 'looking_for_details') {
          return <td key={index}>{this.lookingForData()}</td>;
        }
        if (field.id === 'project_type') {
          return <td key={index}>{job.project.project_type}</td>;
        }
        if (field.id === 'posted_date') {
          return <td key={index} style={{ minWidth: '200px' }}>
            {DateHelpers.timeStampToLabel(job.project.created_at.replace(' ', 'T'), true)}
          </td>
        }
        if (field.id === 'city') {
          return <td key={index}>{job.city}</td>;
        }
        if (field.id === 'job_dates') {
          return <td key={index} style={{ minWidth: '200px' }}>{job.datesString()}</td>;
        }
        if (field.id === 'package_link') {
          return <td key={index}>
            <a
              target="_blank"
              href={`http://www.swipecast.com/project/${
                job.project.swipecast_project_id
              }?share_id=${job.project.secret_alias_id}`}
            >
              View Applicants
            </a>
          </td>;
        }
        if (field.id === 'third_party_link') {
          return <td key={index}>
            {job.awaitingThirdParty() ? (
              <a
                target="_blank"
                href={`http://www.swipecast.com/third_party_pay/${job.secret_alias_id}`}
              >
                Third Party Link
              </a>
            ) : (
              <p>N/A</p>
            )}
          </td>;
        }
        if (field.id === 'applicants_list') {
          return <Button key={index}
              onClick={() => {
                this.props.showApplicantListModal(job.swipecast_job_id);
              }}
              style={{ marginLeft: '20px' }}
            >
              {' '}
              View Applicants List
          </Button>;
        }
        if (field.id === 'manual_ordering') {
          return  <td key={index} style={{ minWidth: '200px' }}>{this.editManualOrderingButton()}</td>;
        }
        if (field.id === 'internal_notes') {
          return <td key={index} style={{ minWidth: '200px' }}>{this.state.swipecast_internal_notes}</td>;
        }
        if (field.id === 'edit_internal_notes') {
          return (<td key={index}>
            <Button
              style={{ marginLeft: '20px' }}
              onClick={() =>
                this.props.showEditModal(
                  'Edit Internal Notes',
                  self.state.swipecast_internal_notes,
                  swipecast_internal_notes =>
                    self.edit('swipecast_internal_notes', swipecast_internal_notes),
                )
              }
            >
              Edit Internal Notes
            </Button>
          </td>);
        }
        if (field.id === 'notes') {
          return  <td key={index} style={{ minWidth: '600px' }}>{job.notes}</td>;
        }
        if (field.id === 'engineering_details') {
          return <td key={index}>
            <a target="_blank" href={self.props.job.viewInfoURL()}>
              <Button style={{ marginLeft: '20px' }}>Engineering Details</Button>
            </a>
          </td>
        }
        if (field.id === 'collected_payment') {
          return (
            <td key={index} style={{ minWidth: '200px' }}>
              Wire / check has been received, QB updated
              <Button
                bsStyle="danger"
                style={{ marginLeft: '20px' }}
                disabled={false}
                onClick={() => this.props.confirmWireCheck(job)}
              >
                Confirm
              </Button>
            </td>
          );
        }
      })}
      </tr>
    );
  }
}

export default JobRow;
